import Marquee from "react-fast-marquee";
import { Button } from "@/components/ui/button";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/c145874f-77be-43ac-ab7b-47d69079da54/images/417a6c32685be65c86ef0c259682a39539d96a2d23871e121b5b2894d1ac3ac9.png";

const tickerItems = [
  "Compounding",
  "Long-Term Conviction",
  "Dollar-Cost Averaging",
  "Start Early, Stay Patient",
  "Make Money Work For You",
  "Dividend Reinvestment",
  "Asymmetric Bets",
  "Value Over Hype",
  "Build Your Portfolio",
  "Smart Money Concepts",
];

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden min-h-[100svh] flex flex-col justify-center"
    >
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_BG}
          alt="Glowing candlestick chart"
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-[#050505]" />
        <div className="absolute inset-0 bg-grid opacity-40" />
        <div className="absolute inset-0 bg-radial-amber" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-40 pb-32">
        <p
          data-testid="hero-eyebrow"
          className="text-xs tracking-[0.35em] uppercase text-amber-500 font-semibold mb-8"
        >
          — Smart Money Investing · Build Your Portfolio Now
        </p>

        <h1
          data-testid="hero-headline"
          className="font-serif-display text-5xl sm:text-7xl lg:text-[8rem] leading-[0.95] tracking-tight text-white max-w-5xl"
        >
          Stop letting the bank
          <br />
          get <em className="italic text-amber-400">richer than you.</em>
        </h1>

        <div className="grid md:grid-cols-12 gap-8 mt-14 items-end">
          <p className="md:col-span-6 text-zinc-400 text-lg leading-relaxed max-w-xl">
            I'm Leo Bianchi — 17 years old, three years deep in the markets,
            and obsessed with long-term investing. Strong picks, strong
            returns, and a long-term mindset that turns small starts into real
            wealth. I work with people who are done watching their savings rot
            in a bank account.
          </p>

          <div className="md:col-span-6 flex flex-wrap gap-4 md:justify-end">
            <Button
              asChild
              data-testid="hero-primary-cta"
              className="bg-amber-600 hover:bg-amber-500 text-black font-medium rounded-full px-8 py-6 text-base"
            >
              <a href="#book">Start Building Now →</a>
            </Button>
            <Button
              asChild
              variant="outline"
              data-testid="hero-secondary-cta"
              className="border-white/20 bg-white/5 hover:bg-white/10 text-white rounded-full px-8 py-6 text-base"
            >
              <a href="#services">See How I Work</a>
            </Button>
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-20 grid grid-cols-2 sm:grid-cols-4 gap-6 border-t border-white/10 pt-10">
          {[
            { k: "3 yrs", l: "In the markets" },
            { k: "80+", l: "People mentored" },
            { k: "Long-term", l: "Investing focus" },
            { k: "Strong", l: "Picks & returns" },
          ].map((s) => (
            <div key={s.l} data-testid={`hero-stat-${s.l.replace(/\s/g,'-').toLowerCase()}`}>
              <div className="font-serif-display text-3xl sm:text-4xl text-white">
                {s.k}
              </div>
              <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 mt-2">
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Ticker */}
      <div
        data-testid="hero-ticker"
        className="border-y border-white/10 bg-black/40 backdrop-blur-md py-5"
      >
        <Marquee gradient gradientColor="#050505" gradientWidth={120} speed={40}>
          {tickerItems.concat(tickerItems).map((t, i) => (
            <span
              key={i}
              className="mx-10 font-serif-display italic text-2xl text-zinc-400"
            >
              {t}
              <span className="mx-10 text-amber-600">✦</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
